(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-size-guide-open]');

    if (openButton) {
      const dialog = document.getElementById(openButton.getAttribute('aria-controls'));

      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }

      return;
    }

    const closeButton = event.target.closest('[data-size-guide-close]');

    if (closeButton) {
      closeButton.closest('[data-size-guide-dialog]')?.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
